import { ReactElement } from "react";

export const DocumentationText = ({ color }: { color?: string }): ReactElement => {

  const className = 'icon icon--documentation-text';
  color = color || '#0076CC';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none" {...{ className }}>
      <path d="M5.99998 8H9.99998M5.99998 10.6667H9.99998M11.3333 14H4.66665C3.93027 14 3.33331 13.403 3.33331 12.6667V3.33333C3.33331 2.59695 3.93027 2 4.66665 2H8.3905C8.56732 2 8.73688 2.07024 8.86191 2.19526L12.4714 5.80474C12.5964 5.92976 12.6666 6.09933 12.6666 6.27614V12.6667C12.6666 13.403 12.0697 14 11.3333 14Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default DocumentationText;